<template>
  <!-- Compact mid-page conversion band — keeps a signup path within reach
       between the feature story and the deep-dive sections. -->
  <section class="ctastrip" aria-labelledby="ctastrip-title">
    <div class="ctastrip-inner" data-reveal="up">
      <div class="ctastrip-card">
        <div class="ctastrip-glow" aria-hidden="true"></div>
        <h2 id="ctastrip-title" class="ctastrip-title">{{ $t('landing.ctastrip_title') }}</h2>
        <NuxtLink :to="localePath('/auth') + '?tab=signup'" class="btn-cyber-primary btn-strip">
          {{ $t('landing.cta_signup') }}
        </NuxtLink>
      </div>
    </div>
  </section>
</template>

<script setup>
const localePath = useLocalePath()
</script>

<style scoped>
/* Mobile-first. Ladder: 480 / 640 / 768 / 1024 / 1280 (variables.css). */

.ctastrip {
  padding: var(--space-6) 0;
}

.ctastrip-inner {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 var(--space-6);
}

.ctastrip-card {
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: var(--space-5);
  padding: var(--space-8) var(--space-6);
  border-radius: var(--radius-xl);
  border: 1px solid rgb(var(--primary-channels) / 0.2);
  background:
    linear-gradient(120deg, rgb(var(--primary-channels) / 0.06), rgb(var(--secondary-channels) / 0.05)),
    var(--surface-color);
}

.ctastrip-glow {
  position: absolute;
  top: -60px;
  left: 50%;
  transform: translateX(-50%);
  width: 70%;
  height: 120px;
  background: radial-gradient(ellipse at center, rgb(var(--primary-channels) / 0.16), transparent 70%);
  filter: blur(30px);
  pointer-events: none;
}

.ctastrip-title {
  position: relative;
  font-family: var(--font-heading);
  font-size: clamp(1.3rem, 1rem + 1.6vw, 1.9rem);
  font-weight: 800;
  line-height: 1.2;
  text-transform: uppercase;
  letter-spacing: -0.01em;
  margin: 0;
  color: var(--text-main);
  text-wrap: balance;
}

.btn-strip {
  position: relative;
  height: 48px !important;
  padding: 0 32px !important;
  font-size: 0.75rem !important;
  width: 100%;
  max-width: 300px;
}

.btn-strip:focus-visible {
  outline: 2px solid var(--primary);
  outline-offset: 3px;
}

@media (min-width: 640px) {
  .ctastrip-card {
    flex-direction: row;
    justify-content: space-between;
    text-align: left;
    padding: var(--space-8) var(--space-10);
  }

  .btn-strip {
    width: auto;
    flex-shrink: 0;
  }
}
</style>
